<template>
  <div>
    <Spinner
      v-if="isLoadingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.FETCHING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isSendingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.CREATING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isDeletingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.DELETING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isEditingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.EDITING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isSnoozingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.SNOOZING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isUnSnoozingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.UN_SNOOZING_ALERT"
    >
    </Spinner>

    <NormalHeaderLayout
      header="Routing status alerts"
      :isWithoutBackground="true"
    >
      <InfoBanner
        v-if="isShowSuccessInfoBanner"
        infoType="success"
        :infoText="successInfoBannerText"
        :displayDuration="5000"
        @onClose="handleSuccessInfoBannerClose"
      ></InfoBanner>
      <InfoBanner
        v-if="isShowErrorInfoBanner"
        infoType="danger"
        :infoText="errorInfoBannerText"
        :displayDuration="4000"
        @onClose="handleErrorInfoBannerClose"
      ></InfoBanner>

      <template v-if="isUserWithoutMemberAccount">
        <NoAccountLinked></NoAccountLinked>
      </template>
      <template
        v-else-if="
          alertsListOfSelectedAccount && !alertsListOfSelectedAccount.length
        "
      >
        <WithoutAlertsRoutingStatus
          @showCreateAlertModal="showCreateAlertModal"
        ></WithoutAlertsRoutingStatus>
      </template>
      <template
        v-else-if="
          alertsListOfSelectedAccount && alertsListOfSelectedAccount.length
        "
      >
        <OverviewRS></OverviewRS>
      </template>

      <CreateAlertsRoutingStatusModal
        v-if="isShowCreateAlertModal"
        :isEditing="isEditingAlert"
        @closeModal="closeCreateAlertModal"
        @submitAlert="submitAlert"
      ></CreateAlertsRoutingStatusModal>

      <SnoozeAlertRSModal
        v-if="isShowSnoozeAlertModal"
        @onSetSnooze="setSnoozeAlert"
        @onCloseModal="closeSnoozeAlertModal"
      ></SnoozeAlertRSModal>

      <DeleteAlertRSModal
        v-if="isShowDeleteAlertModal"
        @onDeleteAlert="setDeleteAlert"
        @onCloseModal="closeDeleteAlertModal"
      >
      </DeleteAlertRSModal>
    </NormalHeaderLayout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';
import WithoutAlertsRoutingStatus from '../components/alertsRoutingStatus/WithoutAlertsRoutingStatus.vue';
import OverviewRS from '../components/alertsRoutingStatus/overview/OverviewRS.vue';
import CreateAlertsRoutingStatusModal from '../components/alertsRoutingStatus/createAlerts/CreateAlertsRoutingStatusModal';
import Spinner from '../components/ui/Spinner.vue';
import InfoBanner from '../components/ui/InfoBanner.vue';
import DeleteAlertRSModal from '../components/alertsRoutingStatus/createAlerts/DeleteAlertRSModal.vue';
import SnoozeAlertRSModal from '../components/alertsRoutingStatus/createAlerts/SnoozeAlertRSModal.vue';
import NoAccountLinked from '../components/ui/NoAccountLinked.vue';
import { SPINNER_TYPE } from '../constants/common';

export default {
  name: 'AlertsRoutingStatus',

  components: {
    NormalHeaderLayout,
    WithoutAlertsRoutingStatus,
    CreateAlertsRoutingStatusModal,
    OverviewRS,
    Spinner,
    InfoBanner,
    DeleteAlertRSModal,
    SnoozeAlertRSModal,
    NoAccountLinked
  },

  data() {
    return {
      SPINNER_TYPE: SPINNER_TYPE
    };
  },

  computed: {
    ...mapState(['isSuccessfulSummaryRequest']),
    ...mapState('dataStore', ['selectedAccount']),
    ...mapState('alertsRoutingStatusStore', [
      'isLoadingData',
      'isSendingData',
      'isDeletingData',
      'isEditingData',
      'isSnoozingData',
      'isUnSnoozingData',
      'isShowCreateAlertModal',
      'isEditingAlert',
      'isShowSnoozeAlertModal',
      'isShowDeleteAlertModal',
      'isShowSuccessInfoBanner',
      'isShowErrorInfoBanner',
      'errorInfoBannerText',
      'successInfoBannerText',
      'alertsRoutingStatusSummary'
    ]),
    ...mapGetters('dataStore', ['noAccount']),
    ...mapGetters('alertsRoutingStatusStore', ['alertsListOfSelectedAccount']),

    isUserWithoutMemberAccount() {
      return this.isSuccessfulSummaryRequest && this.noAccount;
    }
  },
  methods: {
    ...mapActions('dataStore', ['selectAccount']),
    ...mapActions('alertsRoutingStatusStore', [
      'createAlert',
      'updateAlert',
      'snoozeAlert',
      'deleteAlert'
    ]),
    ...mapMutations('alertsRoutingStatusStore', [
      'setIsShowCreateAlertModal',
      'setIsShowSnoozeAlertModal',
      'setIsShowDeleteAlertModal',
      'setIsShowSuccessInfoBanner',
      'setIsShowErrorInfoBanner',
      'setIsEditingAlert',
      'setEditingAlertObj'
    ]),

    showCreateAlertModal() {
      // this.fetchAverageHit();
      this.setIsShowCreateAlertModal(true);
    },
    closeCreateAlertModal() {
      this.setIsShowCreateAlertModal(false);
      this.setEditingAlertObj({});
      this.setIsEditingAlert(false);
    },
    closeSnoozeAlertModal() {
      this.setIsShowSnoozeAlertModal(false);
    },
    closeDeleteAlertModal() {
      this.setIsShowDeleteAlertModal(false);
    },
    submitAlert(val) {
      if (this.isEditingAlert) {
        this.updateAlert(val);
      } else {
        this.createAlert(val);
      }
      this.closeCreateAlertModal();
    },
    setSnoozeAlert(val) {
      this.snoozeAlert(val);
      this.closeSnoozeAlertModal();
    },
    setDeleteAlert(val) {
      this.deleteAlert(val);
      this.closeDeleteAlertModal();
    },
    handleSuccessInfoBannerClose() {
      this.setIsShowSuccessInfoBanner(false);
    },
    handleErrorInfoBannerClose() {
      this.setIsShowErrorInfoBanner(false);
    }
  },
  mounted() {
    const memberId = this.selectedAccount && this.selectedAccount.id;
    memberId && this.selectAccount(memberId);
  }
};
</script>

<style lang="scss" scoped></style>
